var $ = require('jquery');

module.exports = function (_super)
{
	this.tabElementId = 'eh-title';

	var self = this;

	var $eh = _super.$eh,
        $ehe = _super.$ehe,
        $eheContent = _super.$eheContent;

	var $titleSection,
	    $bgSection,
	    $titleCheck,
	    $bgCheck,
	    $fontFamilyCombo,
	    $fontStyleCombo,
	    $fontSizeCombo,
        $fontAlign,
	    $titleText,
	    $colorPicker,
	    $bgColorPicker,
	    optionControlMapper = {},
	    $combos = {};

	var sliderIds = {
	    //modelOptionName => id
        titleHorPos: '#eh-position-hor-slider',
        titleVertPos: '#eh-position-vert-slider',
        titleBackgroundHorPos: '#eh-bg-position-hor-slider',
        titleBackgroundVertPos: '#eh-bg-position-vert-slider',
        titleBackgroundWidth: '#eh-bg-width-slider',
        titleBackgroundHeight: '#eh-bg-height-slider',
        titleBackgroundOpacity: '#eh-bg-opacity-slider'
	};

    var fontAlignButtons = {
        left: 'eh-title-font-align-left',
        center: 'eh-title-font-align-center',
        right: 'eh-title-font-align-right'
    };

	this.model = _super.model;

	this.init = function()
	{
		this.viewWrapper.actionController(this, {events: 'change keydown'});

	    this.initElements();
	    this.initButtons();
		this.initSliders();
		this.initCombos();
		this.initPickers();
		this.initFieldsets();
		this.createTabs();
	};

	this.initElements = function() {
	    $titleCheck = $('#eh-show-title', $eheContent);
        $bgCheck = $('#eh-show-title-bg', $eheContent).diy_checkbox();
        $titleSection = $('#eh-title-settings', $eheContent);
        $bgSection = $('#eh-title-bg-settings', $eheContent);

        $fontFamilyCombo = $('#eh-title-font-family', $eheContent);
        $fontStyleCombo = $('#eh-title-font-weight', $eheContent);
        $fontSizeCombo = $('#eh-title-font-size', $eheContent);
        $fontAlign = $('#eh-title-font-align', $eheContent);

        $titleText = $('#eh-title-text', $eheContent);
	};

    this.initButtons = function () {
        for (var align in fontAlignButtons) {
            $('#' + fontAlignButtons[align]).click(this.fontAlignChange.bind(this).curry(align))
        }
    };

	this.initSliders = function()
	{
        for (var opt in sliderIds) {
		    var invertValue = opt === 'titleVertPos' || opt === 'titleBackgroundVertPos'
		    _super.initSlider({option: opt, id: sliderIds[opt],
	            min: 0, max: 100,
	            step: 0.01,
	            formatter: function (val) {
	                return val + '%';
	            }
	        }, optionControlMapper, this.model, invertValue);		    
		}
	};

	this.initCombos = function()
	{
	    $fontFamilyCombo.diy_combobox({
	        editable: false,
	        select: this.fontFamilyChange,
	        refreshInput: this.refreshFontFamily,
	        renderItem: function(elem, item) {
	            elem.text(item.label);
	            self.refreshFontFamily(elem, item);
	        }
	    });
	    $fontStyleCombo.diy_combobox({
	        editable: false,
	        select: this.fontWeightChange,
            refreshInput: this.refreshFontStyle,
            renderItem: function(elem, item) {
                elem.text(item.label);
                self.refreshFontStyle(elem, item);
            }
        });
	    $fontSizeCombo.diy_combobox({
          editable: true,
	        change: this.fontSizeChange,
	        maskRe: /[0-9]/
	    });
	};

	this.initPickers = function()
	{
		$colorPicker = $eheContent.find('#eh-title-color').colorPicker({
		    mode: 'button',
		    onColorAccept: this.fontColorHandler,
		    onColorSelect: this.fontColorHandler
		});

	    $bgColorPicker = $eheContent.find('#eh-title-bg-color').colorPicker({
		    mode: 'button',
		    onColorAccept: this.backgroundColorHandler,
		    onColorSelect: this.backgroundColorHandler
		});

        CC.EmotionHeader.bind('switchView', function(viewName) {
            if ($colorPicker.isColorButtonOpened()) {
                $colorPicker.abortColor();
            }

            if ($bgColorPicker.isColorButtonOpened()) {
                $bgColorPicker.abortColor();
            }
        });

	    CC.EmotionHeader.bind('collapse', CC.EmotionHeader.toHandler(
	        function(e, data, status) {
	            if(status == 'ok') {
	                $colorPicker.saveColor();
	                $bgColorPicker.saveColor();
	            } else {
	                $colorPicker.abortColor();
	                $bgColorPicker.abortColor();
	            }
	        })
        );
	};

	this.initFieldsets = function()
	{
		$titleSection.fieldset({ collapsed: true });
		$titleSection.bind('toggle.fieldset', function(e, show) {
		    self.model.setTitleVisible(show ? 1 : 0);
		    $(document).trigger('diy-eh-component-visibility-changed', {
		        'componentName': 'title',
		        'show': show
		    });
		});
		$bgCheck.bind('change.checkbox', function() {
		    var show = $(this).is(':checked');
		    self.model.setTitleBackgroundVisible(show ? 1 : 0);
            self.viewWrapper.find('.eh-title-content')
                .diy_simpleTabs('option', 'activeTabIndex', show ? 1 : 0);

            $(document).trigger('diy-eh-component-visibility-changed', {
                'componentName': 'titleBg',
                'show': show
            });
		});
	};
	
	this.createTabs = function () {
	    this.viewWrapper.find('.eh-title-content').diy_simpleTabs({
            activeTabCls: 'diy-tabs-item-selected ui-icon-hover',
        });
    };

	this.updateView = function(model, data, changed, extra)
	{
	    //Don't update if changes came from components in this tab
	    if (extra && extra.from == this) {
            return;
        }

	    for(var option in changed) {
	        var value = changed[option];
	        switch (option) {
	            case 'font':
	                $fontFamilyCombo.diy_combobox('rawValue', value);
	                break;

	            case 'fontWeight':
	            case 'fontStyle':
	                var newStyle = model.getFontStyle();
	                var newWeight = model.getFontWeight();
	                var newValue = getCombinedFontStyle(newWeight, newStyle);
	                $fontStyleCombo.diy_combobox('rawValue', newValue);
	                break;

	            case 'fontSize':
	                $fontSizeCombo.diy_combobox('rawValue', value);
	                break;

                case 'fontAlign':
                    $fontAlign.val(value);
                    $('.eh-title-font-align-button', $eheContent).removeClass('selected');
                    $('#eh-title-font-align-' + value, $eheContent).addClass('selected');
                    break;

                case 'title':
	                $titleText.val(value);
	                break;

	            case 'titleVisible':
	                $titleSection.fieldset('setCollapsed', !value);
	                break;

	            case 'titleBackgroundVisible':
	                $bgCheck.diy_checkbox('option', 'checked', value);
                    self.viewWrapper.find('[data-simpletab=".eh-bgtitle-settings-section"]')
                        .css('visibility', value ? '' : 'hidden');
	                break;

	            case 'fontColor':
	                $colorPicker.setColor('#' + value);
	                break;

	            case 'titleBackgroundColor':
	                $bgColorPicker.setColor('#' + value);
	                break;

	            default:
	                if (option in sliderIds) {
	                    optionControlMapper[option].setValue(value)
	                }
	                break;
	        }
	    }
	};

	this.refreshFontFamily = function(elem, item) {
	    if (!item.option) {
	        return;
	    }
	    var value = item.rawValue;
	    elem.css('font-family', value);
	};

	this.refreshFontStyle = function(elem, item) {
	    if (!item.option) {
	        return;
	    }
	    var value = item.rawValue;
        var fontStyle = value == 'italic' || value == 'both' ? 'italic' : 'normal';
        var fontWeight = value == 'bold' || value == 'both' ? 'bold' : 'normal';

        elem.css({
            'font-style': fontStyle,
            'font-weight': fontWeight
        });
	};

    this.fontAlignChange = function (ui, e) {
        self.model.set({fontAlign: ui});
    };

    this.fontFamilyChange = function ( e, ui )
	{
        self.model.setFont(ui.rawValue, undefined, { from: self });
	};

	this.fontWeightChange = function ( e, ui )
	{
	    var value = ui.rawValue;
	    var fontStyle = value == 'italic' || value == 'both' ? 'italic' : 'normal';
	    var fontWeight = value == 'bold' || value == 'both' ? 'bold' : 'normal';
	    self.model.set({
	        fontWeight: fontWeight,
	        fontStyle: fontStyle
	    }, undefined, { from: self });
	};

	this.fontSizeChange = function ( e, ui )
	{
	    var value = parseInt(ui.rawValue);
	    // parseInt returns NaN for empty strings. fall back to model value.
	    if (isNaN(value)) {
	        $(this).diy_combobox('rawValue', self.model.getFontSize() );
	        return;
	    }

	    //TODO: replace this with a proper validator
	    if (value < 8 || value > 300) {
    	    value = value < 8 ? 8 : 300;
    	    $(this).diy_combobox('rawValue', value);
	    }

	    self.model.setFontSize(value, undefined, { from: self });
	};

	this.titleChangeKeydown = function ()
	{
	    /* XXX: Is this still needed?
	     * IE has a bug, if you change the text
	     * of container with white-space: pre;
	     * it forgets pre ... so I set br instead
	     */
	    var $textarea = $(this);
	    setTimeout(function(){
	        self.model.setTitle($textarea.val(), undefined, {from: self});
	        }, 10);
	};

    this.fontColorHandler = function(color) {
        self.model.setFontColor(color, undefined, {from: self});
    };

    this.backgroundColorHandler = function(color) {
        self.model.setTitleBackgroundColor(color, undefined, {from: self});
    };

	this.destroy = function()
	{
	    $colorPicker.remove();
	    $bgColorPicker.remove();
	    $('.ui-slider', $eheContent).diy_slider('destroy');
	    $('.fieldset', $eheContent).each(function() {
	        $(this).fieldset('destroy');
	    });
	};

	var getCombinedFontStyle = function(weight, style)
	{
	    var newValue;
        if (weight == 'bold') {
            newValue = (style == 'italic') ? 'both' : 'bold';
        } else {
            newValue = style;
        }
        return newValue;
	};
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/emotion-header/CC.EmotionHeader.Title.js
 ** module id = 873
 ** module chunks = 0
 **/